<template>
	<span
		class="icon icon--help"
		:class="isHovered ? 'icon--dark' : `icon--${iconColor}`"
		v-tooltip="tooltipConfig"
		@click.prevent="onClick"
		@mouseenter="onHover(true)"
		@mouseleave="onHover(false)"
	/>
</template>

<script src="./InfoIcon.js"></script>
